import { useQuery } from '@tanstack/react-query'
import { listSmokerRateOverrideRules } from '../../../../../api/plan-smoker-rate-override-rules-api'
import type { ListPlanSmokerRateOverrideRulesQueryDto } from '../../../../../api/dto/plan-smoker-rate-override-rules.dto'

export const SMOKER_RATE_OVERRIDE_RULES_QUERY_KEY = 'smokerRateOverrideRules'

export function useGetSmokerRateOverrideRules(
  params: ListPlanSmokerRateOverrideRulesQueryDto
) {
  const { data, isLoading, error } = useQuery({
    queryKey: [SMOKER_RATE_OVERRIDE_RULES_QUERY_KEY, params],
    queryFn: () => listSmokerRateOverrideRules(params),
    staleTime: 30_000,
  })

  return {
    items: data?.data ?? [],
    total: data?.meta.total ?? 0,
    page: data?.meta.page ?? 1,
    limit: data?.meta.limit ?? 20,
    totalPages: data?.meta.totalPages ?? 0,
    isLoading,
    error,
  }
}
